import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";
import { ResponseHandler } from "@service/system/responseHandler.service";
import { DistinctLearner, ServiceResponse, topCourseCompletions, topOrgCompletions } from "@appcore/data";

const API_URL = API.API_URL;

@Injectable()
export class DashboardsService {
	private _dashboardsURL = API_URL + "/dashboard";
	private _insightsURL = API_URL + "/insight";

	constructor(private responseHandler: ResponseHandler, private httpManager: HttpManager) {}

	getOrganizationCompletions_top(): Observable<ServiceResponse<topOrgCompletions[]>> {
		return this.responseHandler.httpGet<topOrgCompletions[]>(this._dashboardsURL + "/toporgs/1/10");
	}

	getCourseCompletions_top(): Observable<ServiceResponse<topCourseCompletions[]>> {
		return this.responseHandler.httpGet<topCourseCompletions[]>(this._dashboardsURL + "/topcourses/1/10");
	}

	getTotalCompletions(): Observable<ServiceResponse<number>> {
		return this.responseHandler.httpGet<number>(this._dashboardsURL + "/totalcompletionsytd");
	}

	getDistinctLearnersPerOrg(sDate: string, eDate: string, format: string): Observable<ServiceResponse<DistinctLearner[]>> {
		return this.responseHandler.httpGet<DistinctLearner[]>(`${this._insightsURL}/distinctlearners/${sDate}/${eDate}/${format}`);
	}

	getDistinctLearnerCEPerOrg(sDate: string, eDate: string, format: string): Observable<ServiceResponse<DistinctLearner[]>> {
		return this.responseHandler.httpGet<DistinctLearner[]>(`${this._insightsURL}/distinctcelearners/${sDate}/${eDate}/${format}`);
	}

	// STILL NEEDS IMPLEMENTING
	getClinicalCompletions_top(startDate: string, endDate: string): Observable<ServiceResponse<any>> {
		return this.responseHandler.httpGet<any>(`${this._insightsURL}/completions/${startDate}/${endDate}/43/1/15/`);
	}
	// STILL NEEDS IMPLEMENTING
	getNonClinicalCompletions_top(startDate: string, endDate: string): Observable<ServiceResponse<any>> {
		return this.responseHandler.httpGet<any>(`${this._insightsURL}/completions/${startDate}/${endDate}/43/1/15/`);
	}
}
